import React from "react";
import Button from '@material-ui/core/Button';
import { Link as RouterLink } from "react-router-dom";
import { Card, CardContent, CardMedia, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    borderRadius: '10px',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    color: '#1a2332',
    border: '1px solid #e6eaf0',
    boxShadow: 'none',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
    },
  },
  media: {
    height: 220,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.1) 100%)',
    },
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2.5),
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    color: '#1b4995',
    fontSize: '1.25rem',
  },
  description: {
    color: '#5c6b7a',
    fontSize: '0.95rem',
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
    flexGrow: 1,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  button: {
    marginTop: 'auto',
    fontWeight: 600,
    color: '#1b4995',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
    },
  },
}));

export default function PostArea(props) {
  const { title, description, image, unikey } = props;
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      {image && typeof image !== 'object' && (
        <CardMedia
          className={classes.media}
          image={image}
          title={title}
        />
      )}
      {image && typeof image === 'object' && (
        <Box style={{ height: '220px', backgroundColor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {image}
        </Box>
      )}
      <CardContent className={classes.content}>
        <Typography variant="h5" component="h3" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="body2" className={classes.description}>
          {description}
        </Typography>
        <Button 
          component={RouterLink} 
          to={`/nachrichten/${unikey}/${title.toString().replace(/\W/g, '')}.html`}
          className={classes.button}
          endIcon={<ArrowForwardIcon />}
        >
          Weiterlesen
        </Button>
      </CardContent>
    </Card>
  );
}

export function PostExtendedArea(props) {
  const { title, description, image, unikey, index } = props;

  return (
    <Box className="spg-news-item">
      <Card className={`spg-news-card${index % 2 === 0 ? '' : ' is-reverse'}`}>
        {image && typeof image !== 'object' && (
          <CardMedia
            className="spg-news-card-media"
            image={image}
            title={typeof title === 'string' ? title : ''}
          />
        )}
        {image && typeof image === 'object' && (
          <Box className="spg-news-card-media is-placeholder">
            {image}
          </Box>
        )}
        <CardContent className="spg-news-card-body">
          <Typography variant="h4" component="h3" className="spg-news-card-title">
            {title}
          </Typography>
          <Typography variant="body1" className="spg-news-card-text">
            {description}
          </Typography>
          <Box className="spg-news-card-action">
            <Button
              component={RouterLink}
              to={`/nachrichten/${unikey}/${String(title || '').replace(/\W/g, '')}.html`}
              variant="contained"
              color="primary"
              endIcon={<ArrowForwardIcon />}
              style={{ textTransform: 'none', fontWeight: 600 }}
            >
              Weiterlesen
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
